import BadgeFormController from './badge.form.controller';

export default {
    template: require('./badge.form.html'),
    controller: BadgeFormController
};
